var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.page.statuses,"label":"Status","outlined":"","hide-details":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})}
var staticRenderFns = []

export { render, staticRenderFns }